import {Module} from '@dms/api/shared';
import {moduleKeys} from '@dms/config';
import {featureFlags} from '@dms/feature-flags';
import {settingsRoutes} from '@dms/routes';
import {
  AccountingActivityLog,
  AccountingCodes,
  AccountingCodesDetail,
  AccountingErrorLog,
  AccountingErrorLogDetail,
  AccountingQrCodeSettings,
  AccountingQrCodeSettingsAdd,
  AccountingQrCodeSettingsEdit,
  ComissionFee,
  CorrectiveTaxDocumentEdit,
  CorrectiveTaxDocumentNew,
  CorrectiveTaxDocuments,
  CreateOrEditInvoiceCanceling,
  CashLimits,
  CashLimitsAdd,
  CashLimitsEdit,
  CashRegisters,
  DocumentRoundingDefinitions,
  DocumentRoundingDefinitionsEdit,
  DocumentRoundingDefinitionsNew,
  EditCashRegister,
  MatrixManagement,
  InvoiceCanceling,
  InvoiceCostDetail,
  InvoiceCostOverview,
  InvoiceDefinition,
  InvoiceMarginOverview,
  InvoiceMarginDetail,
  NewCashRegister,
  PreAccountingProcessingDetail,
  PreAccountingProcessingNew,
  PreAccountingProcessingOverview,
  ProformaCreationDetail,
  ProformaCreationOverview,
  ProformaInvoiceGenerationDetail,
  ProformaInvoiceGenerationNew,
  ProformaInvoiceGenerationOverview,
  TaxDocumentForPaymentImportTypeDetail,
  TaxDocumentForPaymentImportTypeNew,
  TaxDocumentForPaymentIssuedTypeDetail,
  TaxDocumentForPaymentIssuedTypeNew,
  TaxDocumentImportTypeOverview,
  TaxDocumentIssuedTypeOverview,
  VatTotalAndCalculationDetail,
  VatTotalAndCalculationOverview,
} from '@dms/settings/accounting';
import {
  AdvertisingQuickPresetsCreate,
  AdvertisingQuickPresetsDetail,
  AddNewGdprConsentType,
  AdvertisingPlatformDetail,
  AdvertisingPlatforms,
  AdvertisingQuickPresets,
  AILeadEmailHistory,
  AiLeadManagement,
  BusinessCaseCentralizedPricing,
  BusinessCaseDefinition,
  BusinessCaseDueDatesDetail,
  BusinessCaseDueDatesOverview,
  BusinessCaseOfferValidityDetail,
  BusinessCaseOfferValidityOverview,
  BusinessCases,
  BussinessCaseCommissionFeeDetail,
  CarRentalSeries,
  CustomerCodeDefinition,
  CustomerCodeDefinitionDetail,
  CustomerVerification,
  CustomerVerificationDistraints,
  CustomFieldsDefinitions,
  EditGdprConsentType,
  Financing,
  GdprConsentTypes,
  Interest,
  InterestDefinition,
  InterestDefinitionDetail,
  MessageTemplateEdit,
  MessageTemplateNew,
  MessageTemplates,
  PhotosWatermarking,
  PhotosWatermarkingDetail,
  PhotosWatermarkingOld,
  PriceGroups,
  PriceGroupsDetail,
  PriceGroupsNew,
  PromoPhotoCreate,
  PromoPhotoDetail,
  PromoPhotos,
  Reservation,
  SalePreset,
  SalePresetDetail,
  ServiceOrderVariants as SalesServiceOrderVariants,
  VehicleCondition,
  VehicleInspections,
  VehicleInspectionsDetail,
  VehicleInspectionsNew,
  VehicleParking,
  VehicleParkingAdd,
  VehicleParkingEdit,
  VehicleSeriesDefinition,
  VehicleEditSeriesDefinition,
  VehicleNewSeriesDefinition,
  VehicleServices,
  VehicleTopMakes,
  VehicleWarehouseDetail,
  VehicleWarehouseManagement,
  Advertising,
  RentalCodelistDetail,
  SalesCodelistDetail,
  WorkshopCodelistDetail,
  SalesLeadsAssignmentNew,
  SalesLeadsAssignment,
  SalesLeadsAssignmentEdit,
} from '@dms/settings/sales';
import {
  Suppliers,
  WarehouseArticleCategory,
  WarehouseArticleCategoryDetail,
  WarehouseDetail,
  WarehouseDirectSaleVariants,
  WarehouseDirectSaleVariantsDetail,
  WarehouseMarketingCode,
  WarehouseMarketingCodeDetail,
  WarehouseSpaces,
  WarehouseSpacesDetail,
  Warehouses,
  WarehousesDispensingUnitsPresets,
  WarehousesDispensingUnitsPresetsDetail,
  WarehousesManufacturers,
  WarehousesMeasurementUnits,
  WarehousesMeasurementUnitsDetail,
  WarehousesSupplierDiscountGroups,
  WarehousesSupplierDiscountGroupsDetail,
  WarehousesSupplierOrderVariantsDetail,
  WarehouseSupplierOrderVariantsList,
  WarehouseTransferOrderVariants,
  WarehouseTransferOrderVariantsDetail,
} from '@dms/settings/warehouse';
import {
  CheckinInspection,
  CustomerContracts,
  CustomerContractsDetail,
  EmployeeCompetencesDetail,
  EmployeeCompetencesOverview,
  EmployeeCostCentersDetail,
  EmployeeCostCentersOverview,
  EmployeeProfessionsDetail,
  EmployeeProfessionsOverview,
  EmployeeWorkTeamsDetail,
  EmployeeWorkTeamsOverview,
  Inspections,
  InspectionsDetail,
  LabourCatalogues,
  LabourCataloguesDetail,
  LabourRates,
  LabourRatesDetail,
  ProductCatalog,
  ServiceCaseType,
  ServiceOrderVariants as WorkshopServiceOrderVariants,
  ServiceCaseTypeDetail,
  ServiceOrderVariantsDetail,
  TireCondition,
  TireConditionDetail,
  TireInventoryAspectRatio,
  TireInventoryAspectRatioDetail,
  TireInventoryCategory,
  TireInventoryCategoryDetail,
  TireInventoryLoadIndex,
  TireInventoryLoadIndexDetail,
  TireInventoryLocations,
  TireInventoryManufacturers,
  TireInventoryRim,
  TireInventoryRimDetail,
  TireInventorySpeedRatio,
  TireInventorySpeedRatioDetail,
  TireInventoryWidth,
  TireInventoryWidthDetail,
  TiresInventory,
  TiresInventoryDetail,
  TireTransit,
  TireTransitDetail,
  TireWarehouses,
  TireWarehousesCreate,
  TireWarehousesDetail,
  VehicleGroups,
  VehicleGroupsDetail,
  WorkshopCustomerGroupFormPage,
  WorkshopCustomerGroups,
  WorkshopInsuranceTypeDetail,
  WorkshopInsuranceTypes,
  WorkshopInterest,
  WorkshopInterestSeriesDefinition,
  WorkshopMeasurementUnitDetail,
  WorkshopMeasurementUnits,
  WorkshopSelectableMaterials,
  WorkshopSelectableMaterialsDetail,
  WorkshopServiceOrderGroupDetail,
  WorkshopServiceOrderGroups,
  WorkshopServicePackageDetail,
  WorkshopServicePackages,
  WorkshopSmallUnitMaterialDetail,
  WorkshopSmallUnitMaterials,
  WorkshopUnits,
  WorkshopUnitsDetail,
  WorkshopVehicleClassDetail,
  WorkshopVehicleClasses,
  WorkType,
  WorkTypeDetail,
  HandoverInspection,
  PartDepartment,
} from '@dms/settings/workshop';
import {permissions, warehousePermissions} from '@dms/shared';

import {AddTeam} from './pages/AddTeam/AddTeam';
import {AddUser} from './pages/AddUser/AddUser';
import {AutostacjaSettings} from './pages/AutostacjaSettings/AutostacjaSettings';
import {AutostacjaSettingsSubscriptionKey} from './pages/AutostacjaSettingsSubscriptionKey/AutostacjaSettingsSubscriptionKey';
import {BackgroundRemoval} from './pages/BackgroundRemoval/BackgroundRemoval';
import {BackgroundRemovalDetail} from './pages/BackgroundRemovalDetail/BackgroundRemovalDetail';
import {BankTransferSettings} from './pages/BankTransferSettings/BankTransferSettings';
import {BillingInfo} from './pages/BillingInfo/BillingInfo';
import {BillingInfoEdit} from './pages/BillingInfoDetail/BillingInfoEdit';
import {BillingInfoNew} from './pages/BillingInfoDetail/BillingInfoNew';
import {BranchDetail} from './pages/BranchDetail/BranchDetail';
import {Branches} from './pages/Branches/Branches';
import {CarpassSettings} from './pages/CarpassSettings/CarpassSettings';
import {CarpassSettingsDetail} from './pages/CarpassSettingsDetail/CarpassSettingsDetail';
import {Cebia} from './pages/Cebia/Cebia';
import {CebiaRokvy} from './pages/CebiaRokvy/CebiaRokvy';
import {ChatSettings} from './pages/ChatSettings/ChatSettings';
import {Checklist} from './pages/Checklist/Checklist';
import {Create as ChecklistCreate} from './pages/Checklist/pages/Create/Create';
import {Detail as ChecklistDetail} from './pages/Checklist/pages/Detail/Detail';
import {Codelists} from './pages/Codelists/Codelists';
import {DigitalDeal} from './pages/DigitalDeal/DigitalDeal';
import {DocumentTemplates} from './pages/DocumentTemplates/DocumentTemplates';
import {EmailServices} from './pages/EmailServices/EmailServices';
import {EsignoService} from './pages/EsignoService/EsignoService';
import {ExportParametersDetail} from './pages/ExportParameters/ExportParametersDetail';
import {FacebookCredentials} from './pages/FacebookCredentials/FacebookCredentials';
import {Features} from './pages/Features/Features';
import {GeneratedDocuments} from './pages/GeneratedDocuments/GeneratedDocuments';
import {InviteUserDetail} from './pages/InviteUserDetail/InviteUserDetail';
import {Jbr} from './pages/JbrSettings/Jbr';
import {JbrSettingsCredentials} from './pages/JbrSettingsCredentials/JbrSettingsCredentials';
import {Locale} from './pages/Locale/Locale';
import {MandatoryFields} from './pages/MandatoryFields/MandatoryFields';
import {NotificationSettingsDetail} from './pages/NotificationSettingsDetail/NotificationSettingsDetail';
import {NotificationSettingsOverview} from './pages/NotificationSettingsOverview/NotificationSettingsOverview';
import {OperationAuthorizationDetail} from './pages/OperationAuthorizationDetail/OperationAuthorizationDetail';
import {OperationAuthorizationsOverview} from './pages/OperationAuthorizationsOverview/OperationAuthorizationsOverview';
import {OperationDefaultsDetail} from './pages/OperationDefaultsDetail/OperationDefaultsDetail';
import {OperationDefaultsOverview} from './pages/OperationDefaultsOverview/OperationDefaultsOverview';
import {PairedDevicesOverview} from './pages/PairedDevicesOverview/PairedDevicesOverview';
import {QrCodeDefinition} from './pages/QrCodeDefinition/QrCodeDefinition';
import {RoleOverview} from './pages/RoleManagement/RoleOverview';
import {ScheduledMessagesDetail} from './pages/ScheduledMessagesDetail/ScheduledMessagesDetail';
import {ScheduledMessagesOverview} from './pages/ScheduledMessagesOverview/ScheduledMessagesOverview';
import {SeriesDefinition} from './pages/SeriesDefinition/SeriesDefinition';
import {SeriesDefinitionEdit} from './pages/SeriesDefinitionDetail/SeriesDefinitionEdit';
import {SeriesDefinitionNew} from './pages/SeriesDefinitionDetail/SeriesDefinitionNew';
import {SmsGateways} from './pages/SmsGateways/SmsGateways';
import {SmsGatewaysKonzulta} from './pages/SmsGatewaysKonzulta/SmsGatewaysKonzulta';
import {TeamDetail} from './pages/TeamDetail/TeamDetail';
import {TeamOverview} from './pages/TeamManagement/TeamOverview';
import {TemplateManagement} from './pages/TemplateManagement/TemplateManagement';
import {Tenant} from './pages/Tenant/Tenant';
import {TenantLogos} from './pages/TenantLogos/TenantLogos';
import {TwoFactorSettings} from './pages/TwoFactorSettings/TwoFactorSettings';
import {UserDetail} from './pages/UserDetail/UserDetail';
import {UserOverviewWrapper} from './pages/UserManagement/UserOverviewWrapper';
import {RoleEdit} from './pages/UserManagementDetail/RoleEdit';
import {UserEdit} from './pages/UserManagementDetail/UserEdit';
import {WhatsApp} from './pages/WhatsApp/WhatsApp';

export const SettingsModule: Module = {
  id: moduleKeys.settings,
  requiredPermission: permissions.readSettings,
  layoutProps: {
    title: 'module.settings.title',
    icon: 'action/settings',
    isLastMenuItem: true,
  },
  routerProps: {
    path: settingsRoutes.userManagement,
    element: <UserOverviewWrapper />,
  },
  content: [
    {
      id: 'settings-home',
      routerProps: {
        path: settingsRoutes.userManagement,
        element: <UserOverviewWrapper />,
      },
      layoutProps: {
        title: 'module.settings.title',
        icon: 'action/settings',
      },
      requiredPermission: permissions.readSettings,
    },
    {
      id: 'advertising',
      routerProps: {
        path: settingsRoutes.advertising,
        element: <Advertising />,
      },
      requiredPermission: permissions.readSettings,
    },
    {
      id: 'advertising-platforms',
      routerProps: {
        path: settingsRoutes.advertisingPlatforms,
        element: <AdvertisingPlatforms />,
      },
      requiredPermission: permissions.readSettings,
    },
    {
      id: 'advertising-quickPresets',
      routerProps: {
        path: settingsRoutes.advertisingQuickPresets,
        element: <AdvertisingQuickPresets />,
      },
      requiredPermission: permissions.readSettings,
    },
    {
      id: 'advertising-quickPresets-create',
      routerProps: {
        path: settingsRoutes.advertisingQuickPresetsCreate,
        element: <AdvertisingQuickPresetsCreate />,
      },
      requiredPermission: permissions.readSettings,
    },
    {
      id: 'advertising-quickPresets-detail',
      routerProps: {
        path: settingsRoutes.advertisingQuickPresetsDetail,
        element: <AdvertisingQuickPresetsDetail />,
      },
      requiredPermission: permissions.readSettings,
    },
    {
      id: 'advertising-platforms-detail',
      routerProps: {
        path: settingsRoutes.advertisingPlatformsDetail,
        element: <AdvertisingPlatformDetail />,
      },
      requiredPermission: permissions.readSettings,
    },
    {
      id: 'advertising-promoPhotos',
      routerProps: {
        path: settingsRoutes.advertisingPromoPhotos,
        element: <PromoPhotos />,
      },
      requiredPermission: permissions.readSettings,
    },
    {
      id: 'advertising-promoPhotos-create',
      routerProps: {
        path: settingsRoutes.advertisingPromoPhotosCreate,
        element: <PromoPhotoCreate />,
      },
      requiredPermission: permissions.readSettings,
    },
    {
      id: 'ai-lead-management',
      routerProps: {
        path: settingsRoutes.aiLeadManagement,
        element: <AiLeadManagement />,
      },
      requiredPermission: permissions.readSettings,
      requiredFeatureFlag: featureFlags.AI_LEAD_MANAGEMENT,
    },
    {
      id: 'ai-lead-management-history',
      routerProps: {
        path: settingsRoutes.aiLeadManagementHistory,
        element: <AILeadEmailHistory />,
      },
      requiredPermission: permissions.readSettings,
      requiredFeatureFlag: featureFlags.AI_LEAD_MANAGEMENT,
    },
    {
      id: 'digital-deal',
      routerProps: {
        path: settingsRoutes.digitalDeal,
        element: <DigitalDeal />,
      },
      requiredPermission: permissions.readSettings,
      requiredFeatureFlag: featureFlags.ONLINE_OFFER_SETTINGS,
    },
    {
      id: 'advertising-promoPhotos-detail',
      routerProps: {
        path: settingsRoutes.advertisingPromoPhotosDetail,
        element: <PromoPhotoDetail />,
      },
      requiredPermission: permissions.readSettings,
    },
    {
      id: 'advertising-watermarking',
      routerProps: {
        path: settingsRoutes.advertisingWatermarking,
        element: <PhotosWatermarking />,
      },
      requiredPermission: permissions.readSettings,
      requiredFeatureFlag: featureFlags.SETTINGS_WATERMARKS,
    },
    {
      id: 'advertising-watermarking-old',
      routerProps: {
        path: settingsRoutes.advertisingWatermarkingOld,
        element: <PhotosWatermarkingOld />,
      },
      requiredPermission: permissions.readSettings,
    },
    {
      id: 'esignoService',
      routerProps: {
        path: settingsRoutes.esignoDetail,
        element: <EsignoService />,
      },
      requiredPermission: permissions.readSettings,
    },
    {
      id: 'advertising-watermarking-detail',
      routerProps: {
        path: settingsRoutes.advertisingWatermarkingDetail,
        element: <PhotosWatermarkingDetail />,
      },
      requiredPermission: permissions.readSettings,
    },
    {
      id: 'PairedDevicesOverview',
      routerProps: {
        path: settingsRoutes.signatures,
        element: <PairedDevicesOverview />,
      },
      requiredPermission: permissions.readSettings,
    },
    {
      id: 'advertising-watermarking-create',
      routerProps: {
        path: settingsRoutes.advertisingWatermarkingCreate,
        element: <PhotosWatermarkingDetail />,
      },
      requiredPermission: permissions.readSettings,
    },
    {
      id: 'advertising-qrCodeDefinition',
      routerProps: {
        path: settingsRoutes.advertisingQrCodeDefinition,
        element: <QrCodeDefinition />,
      },
      requiredPermission: permissions.readSettings,
    },
    {
      id: 'advertising-backgroundRemoval',
      routerProps: {
        path: settingsRoutes.backgroundRemoval,
        element: <BackgroundRemoval />,
      },
      requiredPermission: permissions.configureBackgroundRemoval,
    },
    {
      id: 'advertising-backgroundRemovalDetail',
      routerProps: {
        path: settingsRoutes.backgroundRemovalDetail,
        element: <BackgroundRemovalDetail />,
      },
      requiredPermission: permissions.configureBackgroundRemoval,
    },
    {
      id: 'advertising-backgroundRemovalCreate',
      routerProps: {
        path: settingsRoutes.backgroundRemovalCreate,
        element: <BackgroundRemovalDetail />,
      },
      requiredPermission: permissions.configureBackgroundRemoval,
    },
    {
      id: 'advertising-salePreset',
      routerProps: {
        path: settingsRoutes.salePreset,
        element: <SalePreset />,
      },
      requiredPermission: permissions.readSettings,
      requiredFeatureFlag: featureFlags.SALES_SALE_PROGRAMS,
    },
    {
      id: 'advertising-salePresetDetail',
      routerProps: {
        path: settingsRoutes.salePresetDetail,
        element: <SalePresetDetail />,
      },
      requiredPermission: permissions.readSettings,
      requiredFeatureFlag: featureFlags.SALES_SALE_PROGRAMS,
    },
    {
      id: 'rental-vehicle-priceGroupList',
      routerProps: {
        path: settingsRoutes.priceGroupList,
        element: <PriceGroups />,
      },
      requiredPermission: [permissions.readSettings, permissions.readRentalVehicle],
    },
    {
      id: 'rental-vehicle-priceGroupNew',
      routerProps: {
        path: settingsRoutes.priceGroupNew,
        element: <PriceGroupsNew />,
      },
      requiredPermission: [permissions.readSettings, permissions.readRentalVehicle],
    },
    {
      id: 'rental-vehicle-priceGroupDetail',
      routerProps: {
        path: settingsRoutes.priceGroupDetail,
        element: <PriceGroupsDetail />,
      },
      requiredPermission: [permissions.readSettings, permissions.readRentalVehicle],
    },
    {
      id: 'rental-vehicle-carRentalSeries',
      routerProps: {
        path: settingsRoutes.carRentalSeries,
        element: <CarRentalSeries />,
      },
      requiredPermission: [permissions.readSettings, permissions.readRentalVehicle],
    },
    {
      id: 'advertising-salePresetCreate',
      routerProps: {
        path: settingsRoutes.salePresetCreate,
        element: <SalePresetDetail />,
      },
      requiredPermission: permissions.readSettings,
      requiredFeatureFlag: featureFlags.SALES_SALE_PROGRAMS,
    },
    {
      id: 'businessCases',
      routerProps: {
        path: settingsRoutes.businessCase,
        element: <BusinessCases />,
      },
      requiredPermission: permissions.readSettings,
    },
    {
      id: 'businessCase-dueDates',
      routerProps: {
        path: settingsRoutes.businessCaseDueDates,
        element: <BusinessCaseDueDatesOverview />,
      },
      requiredPermission: permissions.readSettings,
    },
    {
      id: 'businessCase-dueDatesDetail',
      routerProps: {
        path: settingsRoutes.businessCaseDueDatesDetail,
        element: <BusinessCaseDueDatesDetail />,
      },
      requiredPermission: permissions.readSettings,
    },
    {
      id: 'businessCase-dueDatesNew',
      routerProps: {
        path: settingsRoutes.businessCaseDueDatesNew,
        element: <BusinessCaseDueDatesDetail />,
      },
      requiredPermission: permissions.readSettings,
    },
    {
      id: 'businessCase-offerValidity',
      routerProps: {
        path: settingsRoutes.businessCaseOfferValidity,
        element: <BusinessCaseOfferValidityOverview />,
      },
      requiredPermission: permissions.readSettings,
      requiredFeatureFlag: featureFlags.OFFER_VALIDITY,
    },
    {
      id: 'businessCase-offerValidityDetail',
      routerProps: {
        path: settingsRoutes.businessCaseOfferValidityDetail,
        element: <BusinessCaseOfferValidityDetail />,
      },
      requiredPermission: permissions.readSettings,
      requiredFeatureFlag: featureFlags.OFFER_VALIDITY,
    },
    {
      id: 'businessCase-offerValidityNew',
      routerProps: {
        path: settingsRoutes.businessCaseOfferValidityNew,
        element: <BusinessCaseOfferValidityDetail />,
      },
      requiredPermission: permissions.readSettings,
      requiredFeatureFlag: featureFlags.OFFER_VALIDITY,
    },
    {
      id: 'businessCases-definition',
      routerProps: {
        path: settingsRoutes.businessCaseDefinition,
        element: <BusinessCaseDefinition />,
      },
      requiredPermission: permissions.readSettings,
    },
    {
      id: 'businessCases-commissionFee',
      routerProps: {
        path: settingsRoutes.businessCaseCommissionFee,
        element: <ComissionFee />,
      },
      requiredPermission: permissions.readSettings,
    },
    {
      id: 'businessCases-editCommissionFee',
      routerProps: {
        path: settingsRoutes.businessCaseEditCommissionFee,
        element: <BussinessCaseCommissionFeeDetail />,
      },
      requiredPermission: permissions.readSettings,
    },
    {
      id: 'businessCases-createCommissionFee',
      routerProps: {
        path: settingsRoutes.businessCaseCreateCommissionFee,
        element: <BussinessCaseCommissionFeeDetail />,
      },
      requiredPermission: permissions.readSettings,
    },
    {
      id: 'businessCases-centralizedPricing',
      routerProps: {
        path: settingsRoutes.businessCaseCentralizedPricing,
        element: <BusinessCaseCentralizedPricing />,
      },
      requiredPermission: permissions.readSettings,
    },
    {
      id: 'vehicleWarehouseManagement',
      routerProps: {
        path: settingsRoutes.vehicleWarehouseManagement,
        element: <VehicleWarehouseManagement />,
      },
      requiredPermission: permissions.readSettings,
    },
    {
      id: 'vehicleWarehouseCreate',
      routerProps: {
        path: settingsRoutes.vehicleWarehouseCreate,
        element: <VehicleWarehouseDetail />,
      },
      requiredPermission: permissions.readSettings,
    },
    {
      id: 'vehicleWarehouseEdit',
      routerProps: {
        path: settingsRoutes.vehicleWarehouseEdit,
        element: <VehicleWarehouseDetail />,
      },
      requiredPermission: permissions.readSettings,
    },
    {
      id: 'interest',
      routerProps: {
        path: settingsRoutes.interest,
        element: <Interest />,
      },
      requiredPermission: permissions.readSettings,
    },
    {
      id: 'interestDefinition',
      routerProps: {
        path: settingsRoutes.interestDefinition,
        element: <InterestDefinition />,
      },
      requiredPermission: permissions.readSettings,
    },
    {
      id: 'interestDefinitionDetail',
      routerProps: {
        path: settingsRoutes.interestDefinitionDetail,
        element: <InterestDefinitionDetail />,
      },
      requiredPermission: permissions.readSettings,
    },
    {
      id: 'salesLeadsAssignment',
      routerProps: {
        path: settingsRoutes.salesLeadsAssignment,
        element: <SalesLeadsAssignment />,
      },
      requiredFeatureFlag: featureFlags.CORE_TEAMS,
      requiredPermission: permissions.readSettings,
    },
    {
      id: 'salesLeadsAssignmentNew',
      routerProps: {
        path: settingsRoutes.salesLeadsAssignmentNew,
        element: <SalesLeadsAssignmentNew />,
      },
      requiredFeatureFlag: featureFlags.CORE_TEAMS,
      requiredPermission: permissions.readSettings,
    },
    {
      id: 'salesLeadsAssignmentEdit',
      routerProps: {
        path: settingsRoutes.salesLeadsAssignmentEdit,
        element: <SalesLeadsAssignmentEdit />,
      },
      requiredFeatureFlag: featureFlags.CORE_TEAMS,
      requiredPermission: permissions.readSettings,
    },
    {
      id: 'productCatalog',
      routerProps: {
        path: settingsRoutes.productCatalog,
        element: <ProductCatalog />,
      },
      requiredPermission: permissions.readSettings,
    },
    {
      id: 'codelists',
      routerProps: {
        path: settingsRoutes.codelists,
        element: <Codelists />,
      },
      requiredPermission: permissions.readSettings,
    },
    {
      id: 'sales-codelistDetail',
      routerProps: {
        path: settingsRoutes.codelistDetail,
        element: <SalesCodelistDetail />,
      },
      requiredPermission: permissions.readSettings,
    },
    {
      id: 'rental-codelistDetail',
      routerProps: {
        path: settingsRoutes.editRentalCodeList,
        element: <RentalCodelistDetail />,
      },
      requiredPermission: permissions.readSettings,
    },
    {
      id: 'notificationsOverview',
      routerProps: {
        path: settingsRoutes.notificationsOverview,
        element: <NotificationSettingsOverview />,
      },
      requiredPermission: permissions.readSettings,
    },
    {
      id: 'notificationsDetail',
      routerProps: {
        path: settingsRoutes.notificationsDetail,
        element: <NotificationSettingsDetail />,
      },
      requiredPermission: permissions.readSettings,
    },
    {
      id: 'vehicleTopMakes',
      routerProps: {
        path: settingsRoutes.vehicleTopMakes,
        element: <VehicleTopMakes />,
      },
      requiredPermission: permissions.readSettings,
    },
    {
      id: 'vehicleSeriesDefinition',
      routerProps: {
        path: settingsRoutes.vehicleSeriesDefinition,
        element: <VehicleSeriesDefinition />,
      },
      requiredPermission: permissions.readSettings,
    },
    {
      id: 'vehicleNewSeriesDefinition',
      routerProps: {
        path: settingsRoutes.vehicleNewSeriesDefinition,
        element: <VehicleNewSeriesDefinition />,
      },
      requiredPermission: permissions.readSettings,
    },
    {
      id: 'vehicleEditSeriesDefinition',
      routerProps: {
        path: settingsRoutes.vehicleEditSeriesDefinition,
        element: <VehicleEditSeriesDefinition />,
      },
      requiredPermission: permissions.readSettings,
    },
    {
      id: 'vehicleInspections',
      routerProps: {
        path: settingsRoutes.vehicleInspections,
        element: <VehicleInspections />,
      },
      requiredPermission: permissions.readSettings,
    },
    {
      id: 'vehicleInspectionsNew',
      routerProps: {
        path: settingsRoutes.vehicleInspectionsNew,
        element: <VehicleInspectionsNew />,
      },
      requiredPermission: permissions.readSettings,
    },
    {
      id: 'vehicleInspectionsEdit',
      routerProps: {
        path: settingsRoutes.vehicleInspectionDetail,
        element: <VehicleInspectionsDetail />,
      },
      requiredPermission: permissions.readSettings,
    },
    {
      id: 'vehicleCondition',
      routerProps: {
        path: settingsRoutes.vehicleCondition,
        element: <VehicleCondition />,
      },
      requiredPermission: permissions.readSettings,
    },
    {
      id: 'vehicleParking',
      routerProps: {
        path: settingsRoutes.vehicleParking,
        element: <VehicleParking />,
      },
      requiredPermission: permissions.readSettings,
    },
    {
      id: 'vehicleParkingAdd',
      routerProps: {
        path: settingsRoutes.vehicleParkingAdd,
        element: <VehicleParkingAdd />,
      },
      requiredPermission: permissions.readSettings,
    },
    {
      id: 'vehicleParkingEdit',
      routerProps: {
        path: settingsRoutes.vehicleParkingEdit,
        element: <VehicleParkingEdit />,
      },
      requiredPermission: permissions.readSettings,
    },
    {
      id: 'customerDefinition',
      routerProps: {
        path: settingsRoutes.customerCodeDefinition,
        element: <CustomerCodeDefinition />,
      },
      requiredPermission: permissions.readSettings,
    },
    {
      id: 'customerCodeDetail',
      routerProps: {
        path: settingsRoutes.customerCodeDefinitionDetail,
        element: <CustomerCodeDefinitionDetail />,
      },
      requiredPermission: permissions.readSettings,
    },
    {
      id: 'bankTransferSettings',
      routerProps: {
        path: settingsRoutes.bankTransferSettings,
        element: <BankTransferSettings />,
      },
      requiredPermission: permissions.readSettings,
    },
    {
      id: 'userManagement',
      routerProps: {
        path: settingsRoutes.userManagement,
        element: <UserOverviewWrapper />,
      },
      requiredPermission: permissions.readSettings,
    },
    {
      id: 'roleManagement',
      routerProps: {
        path: settingsRoutes.roleManagement,
        element: <RoleOverview />,
      },
      requiredPermission: permissions.updateRole,
    },
    {
      id: 'teamManagement',
      routerProps: {
        path: settingsRoutes.teamManagement,
        element: <TeamOverview />,
      },
      requiredPermission: [permissions.readSettings, permissions.teamRead],
      requiredFeatureFlag: featureFlags.CORE_TEAMS,
    },
    {
      id: 'teamManagementAddTeam',
      routerProps: {
        path: settingsRoutes.teamManagementAddTeam,
        element: <AddTeam />,
      },
      requiredPermission: [permissions.readSettings, permissions.teamCreate],
      requiredFeatureFlag: featureFlags.CORE_TEAMS,
    },
    {
      id: 'teamManagementDetail',
      routerProps: {
        path: settingsRoutes.teamManagementDetail,
        element: <TeamDetail />,
      },
      requiredPermission: [permissions.readSettings, permissions.teamRead],
      requiredFeatureFlag: featureFlags.CORE_TEAMS,
    },
    {
      id: 'userManagementCreate',
      routerProps: {
        path: settingsRoutes.userManagementAddUser,
        element: <AddUser />,
      },
      requiredPermission: permissions.readSettings,
    },
    {
      id: 'userManagementDetail',
      routerProps: {
        path: settingsRoutes.userManagementDetail,
        element: <UserEdit />,
      },
      requiredPermission: permissions.readSettings,
    },
    {
      id: 'userManagementDetailV2',
      routerProps: {
        path: settingsRoutes.userManagementDetailV2,
        element: <UserDetail />,
      },
      requiredPermission: permissions.readSettings,
    },
    {
      id: 'userManagementAddUserV2',
      routerProps: {
        path: settingsRoutes.userManagementAddUserV2,
        element: <UserDetail />,
      },
      requiredPermission: permissions.readSettings,
    },
    {
      id: 'userManagementInviteUser',
      routerProps: {
        path: settingsRoutes.userManagementInviteUser,
        element: <InviteUserDetail />,
      },
      requiredPermission: permissions.readSettings,
    },
    {
      id: 'roleManagementDetail',
      routerProps: {
        path: settingsRoutes.roleManagementDetail,
        element: <RoleEdit />,
      },
      requiredPermission: permissions.readSettings,
    },
    {
      id: 'documentTemplates',
      routerProps: {
        path: settingsRoutes.documentTemplates,
        element: <DocumentTemplates />,
      },
      requiredPermission: permissions.readSettings,
    },
    {
      id: 'templateManagement',
      routerProps: {
        path: settingsRoutes.templateManagement,
        element: <TemplateManagement />,
      },
      requiredPermission: permissions.readSettings,
      requiredFeatureFlag: featureFlags.AUTH_PROFILES_TEMPLATES,
    },
    {
      id: 'warehouses',
      routerProps: {
        path: settingsRoutes.warehousesList,
        element: <Warehouses />,
      },
      requiredPermission: warehousePermissions.warehouseDictionaryRead,
    },
    {
      id: 'warehouseDetail',
      routerProps: {
        paths: [settingsRoutes.warehousesDetail, settingsRoutes.warehousesCreate],
        element: <WarehouseDetail />,
      },
      requiredPermission: warehousePermissions.warehouseDictionaryRead,
    },
    {
      id: 'warehouseMarketingCode',
      routerProps: {
        path: settingsRoutes.warehousesMarketingCode,
        element: <WarehouseMarketingCode />,
      },
      requiredPermission: warehousePermissions.warehouseDictionaryRead,
    },
    {
      id: 'warehouseMarketingCodeAdd',
      routerProps: {
        path: settingsRoutes.warehousesMarketingCodeCreate,
        element: <WarehouseMarketingCodeDetail />,
      },
      requiredPermission: warehousePermissions.warehouseDictionaryRead,
    },
    {
      id: 'warehouseMarketingCodeDetail',
      routerProps: {
        path: settingsRoutes.warehousesMarketingCodeDetail,
        element: <WarehouseMarketingCodeDetail />,
      },
      requiredPermission: warehousePermissions.warehouseDictionaryRead,
    },
    {
      id: 'warehouseDirectSaleVariants',
      routerProps: {
        path: settingsRoutes.warehousesDirectSaleVariants,
        element: <WarehouseDirectSaleVariants />,
      },
      requiredPermission: warehousePermissions.warehouseDictionaryRead,
    },
    {
      id: 'warehouseDirectSaleVariantsAdd',
      routerProps: {
        path: settingsRoutes.warehousesDirectSaleVariantsCreate,
        element: <WarehouseDirectSaleVariantsDetail />,
      },
      requiredPermission: warehousePermissions.warehouseDictionaryRead,
    },
    {
      id: 'warehouseDirectSaleVariantsDetail',
      routerProps: {
        path: settingsRoutes.warehousesDirectSaleVariantsDetail,
        element: <WarehouseDirectSaleVariantsDetail />,
      },
      requiredPermission: warehousePermissions.warehouseDictionaryRead,
    },
    {
      id: 'warehouseSupplierOrderVariantsList',
      routerProps: {
        path: settingsRoutes.warehousesSupplierOrderVariants,
        element: <WarehouseSupplierOrderVariantsList />,
      },
      requiredPermission: warehousePermissions.warehouseDictionaryRead,
    },
    {
      id: 'warehouseSupplierOrderVariantsAdd',
      routerProps: {
        path: settingsRoutes.warehousesSupplierOrderVariantsCreate,
        element: <WarehousesSupplierOrderVariantsDetail />,
      },
      requiredPermission: warehousePermissions.warehouseDictionaryRead,
    },
    {
      id: 'warehouseSupplierOrderVariantsDetail',
      routerProps: {
        path: settingsRoutes.warehousesSupplierOrderVariantsDetail,
        element: <WarehousesSupplierOrderVariantsDetail />,
      },
      requiredPermission: warehousePermissions.warehouseDictionaryRead,
    },
    {
      id: 'warehouseTransferOrderVariants',
      routerProps: {
        path: settingsRoutes.warehousesTransferOrderVariants,
        element: <WarehouseTransferOrderVariants />,
      },
      requiredPermission: warehousePermissions.warehouseDictionaryRead,
    },
    {
      id: 'warehouseTransferOrderVariantsAdd',
      routerProps: {
        path: settingsRoutes.warehousesTransferOrderVariantsCreate,
        element: <WarehouseTransferOrderVariantsDetail />,
      },
      requiredPermission: warehousePermissions.warehouseDictionaryRead,
    },
    {
      id: 'warehouseTransferOrderVariantsDetail',
      routerProps: {
        path: settingsRoutes.warehousesTransferOrderVariantsDetail,
        element: <WarehouseTransferOrderVariantsDetail />,
      },
      requiredPermission: warehousePermissions.warehouseDictionaryRead,
    },
    {
      id: 'warehouseArticleCategory',
      routerProps: {
        path: settingsRoutes.warehousesArticleCategory,
        element: <WarehouseArticleCategory />,
      },
      requiredPermission: warehousePermissions.warehouseDictionaryRead,
    },
    {
      id: 'warehouseArticleCategoryAdd',
      routerProps: {
        path: settingsRoutes.warehousesArticleCategoryCreate,
        element: <WarehouseArticleCategoryDetail />,
      },
      requiredPermission: warehousePermissions.warehouseDictionaryRead,
    },
    {
      id: 'warehouseArticleCategoryDetail',
      routerProps: {
        path: settingsRoutes.warehousesArticleCategoryDetail,
        element: <WarehouseArticleCategoryDetail />,
      },
      requiredPermission: warehousePermissions.warehouseDictionaryRead,
    },
    {
      id: 'warehouseManufacturers',
      routerProps: {
        path: settingsRoutes.warehousesManufacturers,
        element: <WarehousesManufacturers />,
      },
      requiredPermission: warehousePermissions.warehouseDictionaryRead,
    },
    {
      id: 'warehouseMeasurementUnits',
      routerProps: {
        path: settingsRoutes.warehousesMeasurementUnits,
        element: <WarehousesMeasurementUnits />,
      },
      requiredPermission: warehousePermissions.warehouseDictionaryRead,
    },
    {
      id: 'warehouseMeasurementUnitsAdd',
      routerProps: {
        path: settingsRoutes.warehousesMeasurementUnitsCreate,
        element: <WarehousesMeasurementUnitsDetail />,
      },
      requiredPermission: permissions.readSettings,
    },
    {
      id: 'warehouseMeasurementUnitsDetail',
      routerProps: {
        path: settingsRoutes.warehousesMeasurementUnitsDetail,
        element: <WarehousesMeasurementUnitsDetail />,
      },
      requiredPermission: permissions.readSettings,
    },
    {
      id: 'warehouseDispensingUnitsPresets',
      routerProps: {
        path: settingsRoutes.warehousesDispensingUnitsPresets,
        element: <WarehousesDispensingUnitsPresets />,
      },
      requiredPermission: permissions.readSettings,
    },
    {
      id: 'warehouseDispensingUnitsPresetsAdd',
      routerProps: {
        path: settingsRoutes.warehousesDispensingUnitsPresetsCreate,
        element: <WarehousesDispensingUnitsPresetsDetail />,
      },
      requiredPermission: permissions.readSettings,
    },
    {
      id: 'warehouseDispensingUnitsPresetsDetail',
      routerProps: {
        path: settingsRoutes.warehousesDispensingUnitsPresetsDetail,
        element: <WarehousesDispensingUnitsPresetsDetail />,
      },
      requiredPermission: permissions.readSettings,
    },
    {
      id: 'warehouseSupplierDiscountGroups',
      routerProps: {
        path: settingsRoutes.warehousesSupplierDiscountGroups,
        element: <WarehousesSupplierDiscountGroups />,
      },
      requiredPermission: warehousePermissions.warehouseDictionaryRead,
    },
    {
      id: 'warehouseSupplierDiscountGroupsDetail',
      routerProps: {
        path: settingsRoutes.warehousesSupplierDiscountGroupsDetail,
        element: <WarehousesSupplierDiscountGroupsDetail />,
      },
      requiredPermission: warehousePermissions.warehouseDictionaryRead,
    },
    {
      id: 'warehouseSpaces',
      routerProps: {
        path: settingsRoutes.warehousesSpaces,
        element: <WarehouseSpaces />,
      },
      requiredPermission: warehousePermissions.warehouseDictionaryRead,
    },
    {
      id: 'warehouseSpacesCreate',
      routerProps: {
        path: settingsRoutes.warehousesSpacesCreate,
        element: <WarehouseSpacesDetail />,
      },
      requiredPermission: warehousePermissions.warehouseDictionaryRead,
    },
    {
      id: 'warehouseSpacesDetail',
      routerProps: {
        path: settingsRoutes.warehousesSpacesDetail,
        element: <WarehouseSpacesDetail />,
      },
      requiredPermission: warehousePermissions.warehouseDictionaryRead,
    },
    {
      id: 'suppliers',
      routerProps: {
        path: settingsRoutes.suppliers,
        element: <Suppliers />,
      },
      requiredPermission: warehousePermissions.warehouseDictionaryRead,
    },
    {
      id: 'gdprConsent',
      routerProps: {
        path: settingsRoutes.gdprConsentTypes,
        element: <GdprConsentTypes />,
      },
      requiredPermission: permissions.readSettings,
    },
    {
      id: 'gdprConsentEdit',
      routerProps: {
        path: settingsRoutes.gdprConsentTypesEdit,
        element: <EditGdprConsentType />,
      },
      requiredPermission: permissions.readSettings,
    },
    {
      id: 'gdprConsentAdd',
      routerProps: {
        path: settingsRoutes.gdprConsentTypesNew,
        element: <AddNewGdprConsentType />,
      },
      requiredPermission: permissions.readSettings,
    },
    {
      id: 'tenant',
      routerProps: {
        path: settingsRoutes.tenant,
        element: <Tenant />,
      },
      requiredPermission: permissions.readSettings,
    },
    {
      id: 'tenantLogos',
      routerProps: {
        path: settingsRoutes.tenantLogos,
        element: <TenantLogos />,
      },
      requiredPermission: permissions.readSettings,
    },
    {
      id: 'billingInfo',
      routerProps: {
        path: settingsRoutes.billingInformation,
        element: <BillingInfo />,
      },
      requiredPermission: permissions.readSettings,
    },
    {
      id: 'billingInfoEdit',
      routerProps: {
        path: settingsRoutes.billingInformationEdit,
        element: <BillingInfoEdit />,
      },
      requiredPermission: permissions.readSettings,
    },
    {
      id: 'billingInfoNew',
      routerProps: {
        path: settingsRoutes.billingInformationNew,
        element: <BillingInfoNew />,
      },
      requiredPermission: permissions.readSettings,
    },
    {
      id: 'customFields',
      routerProps: {
        path: settingsRoutes.customFields,
        element: <CustomFieldsDefinitions />,
      },
      requiredPermission: permissions.readSettings,
    },
    {
      id: 'seriesDefinition',
      routerProps: {
        path: settingsRoutes.seriesDefinition,
        element: <SeriesDefinition />,
      },
      requiredPermission: permissions.readSettings,
    },
    {
      id: 'seriesDefinitionEdit',
      routerProps: {
        path: settingsRoutes.seriesDefinitionEdit,
        element: <SeriesDefinitionEdit />,
      },
      requiredPermission: permissions.readSettings,
    },
    {
      id: 'seriesDefinitionNew',
      routerProps: {
        path: settingsRoutes.seriesDefinitionNew,
        element: <SeriesDefinitionNew />,
      },
      requiredPermission: permissions.readSettings,
    },
    {
      id: 'correctiveTaxDocuments',
      routerProps: {
        path: settingsRoutes.correctiveTaxDocuments,
        element: <CorrectiveTaxDocuments />,
      },
      requiredPermission: permissions.readSettings,
    },
    {
      id: 'correctiveTaxDocumentsNew',
      routerProps: {
        path: settingsRoutes.correctiveTaxDocumentsNew,
        element: <CorrectiveTaxDocumentNew />,
      },
      requiredPermission: permissions.readSettings,
    },
    {
      id: 'correctiveTaxDocumentsEdit',
      routerProps: {
        path: settingsRoutes.correctiveTaxDocumentsEdit,
        element: <CorrectiveTaxDocumentEdit />,
      },
      requiredPermission: permissions.readSettings,
    },
    {
      id: 'messageTemplates',
      routerProps: {
        path: settingsRoutes.messageTemplates,
        element: <MessageTemplates />,
      },
      requiredPermission: permissions.readSettings,
    },
    {
      id: 'messageTemplatesNew',
      routerProps: {
        path: settingsRoutes.messageTemplatesNew,
        element: <MessageTemplateNew />,
      },
      requiredPermission: permissions.readSettings,
    },
    {
      id: 'messageTemplatesEdit',
      routerProps: {
        path: settingsRoutes.messageTemplatesEdit,
        element: <MessageTemplateEdit />,
      },
      requiredPermission: permissions.readSettings,
    },
    {
      id: 'branches',
      routerProps: {
        path: settingsRoutes.branches,
        element: <Branches />,
      },
      requiredPermission: permissions.readSettings,
    },
    {
      id: 'branchEdit',
      routerProps: {
        path: settingsRoutes.branchesEdit,
        element: <BranchDetail />,
      },
      requiredPermission: permissions.readSettings,
    },
    {
      id: 'branchNew',
      routerProps: {
        path: settingsRoutes.branchesNew,
        element: <BranchDetail />,
      },
      requiredPermission: permissions.readSettings,
    },
    {
      id: 'cashRegisters',
      routerProps: {
        path: settingsRoutes.cashRegisters,
        element: <CashRegisters />,
      },
      requiredPermission: permissions.readSettings,
    },
    {
      id: 'cashRegisterEdit',
      routerProps: {
        path: settingsRoutes.cashRegistersDetail,
        element: <EditCashRegister />,
      },
      requiredPermission: permissions.readSettings,
    },
    {
      id: 'newCashRegister',
      routerProps: {
        path: settingsRoutes.newCashRegister,
        element: <NewCashRegister />,
      },
      requiredPermission: permissions.readSettings,
    },
    {
      id: 'cashLimits',
      routerProps: {
        path: settingsRoutes.cashLimits,
        element: <CashLimits />,
      },
      requiredPermission: permissions.readSettings,
    },
    {
      id: 'cashLimitEdit',
      routerProps: {
        path: settingsRoutes.cashLimitsEdit,
        element: <CashLimitsEdit />,
      },
      requiredPermission: permissions.readSettings,
    },
    {
      id: 'cashLimitAdd',
      routerProps: {
        path: settingsRoutes.cashLimitsAdd,
        element: <CashLimitsAdd />,
      },
      requiredPermission: permissions.readSettings,
    },
    {
      id: 'qrCodeSettings',
      routerProps: {
        path: settingsRoutes.qrCodeSettings,
        element: <AccountingQrCodeSettings />,
      },
      requiredPermission: permissions.readSettings,
    },
    {
      id: 'qrCodeSettingsEdit',
      routerProps: {
        path: settingsRoutes.qrCodeSettingsEdit,
        element: <AccountingQrCodeSettingsEdit />,
      },
      requiredPermission: permissions.readSettings,
    },
    {
      id: 'qrCodeSettingsAdd',
      routerProps: {
        path: settingsRoutes.qrCodeSettingsAdd,
        element: <AccountingQrCodeSettingsAdd />,
      },
      requiredPermission: permissions.readSettings,
    },
    {
      id: 'invoiceDefinition',
      routerProps: {
        path: settingsRoutes.invoiceDefinition,
        element: <InvoiceDefinition />,
      },
      requiredPermission: permissions.readSettings,
    },
    {
      id: 'documentRoundingDefinitions',
      routerProps: {
        path: settingsRoutes.documentRoundingDefinitions,
        element: <DocumentRoundingDefinitions />,
      },
      requiredPermission: permissions.readSettings,
    },
    {
      id: 'documentRoundingDefinitionEdit',
      routerProps: {
        path: settingsRoutes.documentRoundingDefinitionsEdit,
        element: <DocumentRoundingDefinitionsEdit />,
      },
      requiredPermission: permissions.readSettings,
    },
    {
      id: 'invoiceCanceling',
      routerProps: {
        path: settingsRoutes.invoiceCanceling,
        element: <InvoiceCanceling />,
      },
      requiredPermission: permissions.readSettings,
    },
    {
      id: 'newInvoiceCanceling',
      routerProps: {
        path: settingsRoutes.newInvoiceCanceling,
        element: <CreateOrEditInvoiceCanceling />,
      },
      requiredPermission: permissions.readSettings,
    },
    {
      id: 'accountingProformaCreationOverview',
      routerProps: {
        path: settingsRoutes.ProformaCreationOverview,
        element: <ProformaCreationOverview />,
      },
      requiredPermission: permissions.readSettings,
    },
    {
      id: 'vatTotalAndCalculationOverview',
      routerProps: {
        path: settingsRoutes.vatTotalAndCalculationOverview,
        element: <VatTotalAndCalculationOverview />,
      },
      requiredPermission: permissions.readSettings,
    },
    {
      id: 'vatTotalAndCalculationDetail',
      routerProps: {
        path: settingsRoutes.vatTotalAndCalculationDetail,
        element: <VatTotalAndCalculationDetail />,
      },
      requiredPermission: permissions.readSettings,
    },
    {
      id: 'vatTotalAndCalculationNew',
      routerProps: {
        path: settingsRoutes.vatTotalAndCalculationNew,
        element: <VatTotalAndCalculationDetail />,
      },
      requiredPermission: permissions.readSettings,
    },
    {
      id: 'accountingTaxDocumentIssuedTypeOverview',
      routerProps: {
        path: settingsRoutes.taxDocumentIssuedType,
        element: <TaxDocumentIssuedTypeOverview />,
      },
      requiredPermission: permissions.readSettings,
    },
    {
      id: 'accountingTaxDocumentImportTypeOverview',
      routerProps: {
        path: settingsRoutes.taxDocumentImportType,
        element: <TaxDocumentImportTypeOverview />,
      },
      requiredPermission: permissions.readSettings,
    },
    {
      id: 'accountingTaxDocumentImportTypeNew',
      routerProps: {
        path: settingsRoutes.taxDocumentImportTypeNew,
        element: <TaxDocumentForPaymentImportTypeNew />,
      },
      requiredPermission: permissions.readSettings,
    },
    {
      id: 'accountingTaxDocumentImportTypeDetail',
      routerProps: {
        path: settingsRoutes.taxDocumentImportTypeDetail,
        element: <TaxDocumentForPaymentImportTypeDetail />,
      },
      requiredPermission: permissions.readSettings,
    },
    {
      id: 'accountingTaxDocumentIssuedTypeNew',
      routerProps: {
        path: settingsRoutes.taxDocumentIssuedTypeNew,
        element: <TaxDocumentForPaymentIssuedTypeNew />,
      },
      requiredPermission: permissions.readSettings,
    },
    {
      id: 'accountingTaxDocumentIssuedTypeDetail',
      routerProps: {
        path: settingsRoutes.taxDocumentIssuedTypeDetail,
        element: <TaxDocumentForPaymentIssuedTypeDetail />,
      },
      requiredPermission: permissions.readSettings,
    },
    {
      id: 'accountingInvoiceCostOverview',
      routerProps: {
        path: settingsRoutes.invoiceCostOverview,
        element: <InvoiceCostOverview />,
      },
      requiredPermission: permissions.readSettings,
    },
    {
      id: 'accountingOperationDefaultsOverview',
      routerProps: {
        path: settingsRoutes.accountingOperationDefaultsOverview,
        element: <OperationDefaultsOverview />,
      },
      requiredPermission: permissions.readSettings,
    },
    {
      id: 'accountingOperationDefaultsDetail',
      routerProps: {
        path: settingsRoutes.accountingOperationDefaultsDetail,
        element: <OperationDefaultsDetail />,
      },
      requiredPermission: permissions.readSettings,
    },
    {
      id: 'generatedDocumentsSettings',
      routerProps: {
        path: settingsRoutes.generatedDocuments,
        element: <GeneratedDocuments />,
      },
      requiredPermission: permissions.readSettings,
    },
    {
      id: 'accountingInvoiceCostNew',
      routerProps: {
        path: settingsRoutes.invoiceCostNew,
        element: <InvoiceCostDetail />,
      },
      requiredPermission: permissions.readSettings,
    },
    {
      id: 'accountingInvoiceCostDetail',
      routerProps: {
        path: settingsRoutes.invoiceCostDetail,
        element: <InvoiceCostDetail />,
      },
      requiredPermission: permissions.readSettings,
    },
    {
      id: 'accountingProformaCreationDetail',
      routerProps: {
        path: settingsRoutes.ProformaCreationEdit,
        element: <ProformaCreationDetail />,
      },
      requiredPermission: permissions.readSettings,
    },
    {
      id: 'accountingProformaCreationCreate',
      routerProps: {
        path: settingsRoutes.ProformaCreationCreate,
        element: <ProformaCreationDetail />,
      },
      requiredPermission: permissions.readSettings,
    },
    {
      id: 'accountingMatrixManagement',
      routerProps: {
        path: settingsRoutes.accountingMatrixManagement,
        element: <MatrixManagement />,
      },
      requiredPermission: permissions.readSettings,
    },
    {
      id: 'exportParameters',
      routerProps: {
        path: settingsRoutes.exportParameters,
        element: <ExportParametersDetail />,
      },
      requiredPermission: permissions.readSettings,
    },
    {
      id: 'accountingCodes',
      routerProps: {
        path: settingsRoutes.accountingCodes,
        element: <AccountingCodes />,
      },
      requiredPermission: permissions.readSettings,
    },
    {
      id: 'accountingCodesDetail',
      routerProps: {
        path: settingsRoutes.accountingCodesDetail,
        element: <AccountingCodesDetail />,
      },
      requiredPermission: permissions.readSettings,
    },
    {
      id: 'accountingOperationAuthorizations',
      routerProps: {
        path: settingsRoutes.accountingOperationAuthorizationsOverview,
        element: <OperationAuthorizationsOverview />,
      },
      requiredPermission: permissions.readSettings,
    },
    {
      id: 'accountingOperationAuthorizationsDetail',
      routerProps: {
        path: settingsRoutes.accountingOperationAuthorizationDetail,
        element: <OperationAuthorizationDetail />,
      },
      requiredPermission: permissions.readSettings,
    },
    {
      id: 'accountingActivityLog',
      routerProps: {
        path: settingsRoutes.accountingActivityLog,
        element: <AccountingActivityLog />,
      },
      requiredPermission: permissions.readSettings,
    },
    {
      id: 'accountingErrorLog',
      routerProps: {
        path: settingsRoutes.accountingErrorLog,
        element: <AccountingErrorLog />,
      },
      requiredPermission: permissions.readSettings,
    },
    {
      id: 'accountingErrorLogDetail',
      routerProps: {
        path: settingsRoutes.accountingErrorLogDetail,
        element: <AccountingErrorLogDetail />,
      },
      requiredPermission: permissions.readSettings,
    },
    {
      id: 'preAccountingProcessingOverview',
      routerProps: {
        path: settingsRoutes.preAccountingProcessingOverview,
        element: <PreAccountingProcessingOverview />,
      },
      requiredPermission: permissions.readSettings,
    },
    {
      id: 'preAccountingProcessingNew',
      routerProps: {
        path: settingsRoutes.preAccountingProcessingNew,
        element: <PreAccountingProcessingNew />,
      },
      requiredPermission: permissions.readSettings,
    },
    {
      id: 'preAccountingProcessingDetail',
      routerProps: {
        path: settingsRoutes.preAccountingProcessingDetail,
        element: <PreAccountingProcessingDetail />,
      },
      requiredPermission: permissions.readSettings,
    },
    {
      id: 'invoiceCancelingDetail',
      routerProps: {
        path: settingsRoutes.invoiceCancelingDetail,
        element: <CreateOrEditInvoiceCanceling />,
      },
      requiredPermission: permissions.readSettings,
    },
    {
      id: 'documentRoundingDefinitionAdd',
      routerProps: {
        path: settingsRoutes.documentRoundingDefinitionsAdd,
        element: <DocumentRoundingDefinitionsNew />,
      },
      requiredPermission: permissions.readSettings,
    },
    {
      id: 'vehicleServices',
      routerProps: {
        path: settingsRoutes.vehicleServices,
        element: <VehicleServices />,
      },
      requiredPermission: permissions.readSettings,
    },
    {
      id: 'autostacjaSettings',
      routerProps: {
        path: settingsRoutes.autostacjaSettings,
        element: <AutostacjaSettings />,
      },
      requiredPermission: permissions.readSettings,
    },
    {
      id: 'autostacjaSettingsSubscriptionKey',
      routerProps: {
        path: settingsRoutes.autostacjaSettingsSubscriptionKey,
        element: <AutostacjaSettingsSubscriptionKey />,
      },
      requiredPermission: permissions.readSettings,
    },
    {
      id: 'jbr',
      routerProps: {
        path: settingsRoutes.jbr,
        element: <Jbr />,
      },
      requiredPermission: permissions.readSettings,
    },
    {
      id: 'jbrSettings',
      routerProps: {
        path: settingsRoutes.jbrSettings,
        element: <JbrSettingsCredentials />,
      },
      requiredPermission: permissions.readSettings,
    },
    {
      id: 'vehicleServicesCarpass',
      routerProps: {
        path: settingsRoutes.vehicleServicesCarpass,
        element: <CarpassSettings />,
      },
      requiredPermission: permissions.readSettings,
    },
    {
      id: 'vehicleServicesCarpassDetail',
      routerProps: {
        path: settingsRoutes.vehicleServicesCarpassDetail,
        element: <CarpassSettingsDetail />,
      },
      requiredPermission: permissions.readSettings,
    },
    {
      id: 'vehicleServicesCebia',
      routerProps: {
        path: settingsRoutes.vehicleServicesCebia,
        element: <Cebia />,
      },
      requiredPermission: permissions.readSettings,
    },
    {
      id: 'vehicleServicesFeatures',
      routerProps: {
        path: settingsRoutes.vehicleServicesFeatures,
        element: <Features />,
      },
      requiredPermission: permissions.readSettings,
    },
    {
      id: 'vehicleServicesCebiaRokvy',
      routerProps: {
        path: settingsRoutes.vehicleServicesRokVy,
        element: <CebiaRokvy />,
      },
      requiredPermission: permissions.readSettings,
    },
    {
      id: 'smsGateways',
      routerProps: {
        path: settingsRoutes.smsGateways,
        element: <SmsGateways />,
      },
      requiredPermission: permissions.readSettings,
    },
    {
      id: 'smsGatewaysKonzulta',
      routerProps: {
        path: settingsRoutes.smsGatewaysKonzulta,
        element: <SmsGatewaysKonzulta />,
      },
      requiredPermission: permissions.readSettings,
    },
    {
      id: 'whatsApp',
      routerProps: {
        path: settingsRoutes.whatsApp,
        element: <WhatsApp />,
      },
      requiredPermission: permissions.readSettings,
      requiredFeatureFlag: featureFlags.WHATSAPP_INTEGRATION,
    },
    {
      id: 'facebookCredentials',
      routerProps: {
        path: settingsRoutes.facebookCredentials,
        element: <FacebookCredentials />,
      },
      requiredPermission: [permissions.readSettings, permissions.readFacebookLeads],
      requiredFeatureFlag: featureFlags.SETTINGS_FACEBOOK,
    },
    {
      id: 'proformaGeneration',
      routerProps: {
        path: settingsRoutes.proformaGeneration,
        element: <ProformaInvoiceGenerationOverview />,
      },
      requiredPermission: permissions.readSettings,
    },
    {
      id: 'proformaGenerationDetail',
      routerProps: {
        path: settingsRoutes.proformaGenerationDetail,
        element: <ProformaInvoiceGenerationDetail />,
      },
      requiredPermission: permissions.readSettings,
    },
    {
      id: 'proformaGenerationNew',
      routerProps: {
        path: settingsRoutes.proformaGenerationNew,
        element: <ProformaInvoiceGenerationNew />,
      },
      requiredPermission: permissions.readSettings,
    },
    {
      id: 'invoiceMargin',
      routerProps: {
        path: settingsRoutes.invoiceMarginOverview,
        element: <InvoiceMarginOverview />,
      },
      requiredPermission: permissions.readSettings,
    },
    {
      id: 'invoiceMargin',
      routerProps: {
        path: settingsRoutes.newInvoiceMargin,
        element: <InvoiceMarginDetail />,
      },
      requiredPermission: permissions.readSettings,
    },
    {
      id: 'invoiceMarginDetail',
      routerProps: {
        path: settingsRoutes.invoiceMarginDetail,
        element: <InvoiceMarginDetail />,
      },
      requiredPermission: permissions.readSettings,
    },
    {
      id: 'emailServices',
      routerProps: {
        path: settingsRoutes.emailServices,
        element: <EmailServices />,
      },
      requiredPermission: permissions.readSettings,
    },
    {
      id: 'customerVerification',
      routerProps: {
        path: settingsRoutes.customerVerificationServices,
        element: <CustomerVerification />,
      },
      requiredPermission: permissions.readSettings,
    },
    {
      id: 'customerVerificationDistraints',
      routerProps: {
        path: settingsRoutes.customerVerificationDistraints,
        element: <CustomerVerificationDistraints />,
      },
      requiredPermission: permissions.readSettings,
    },
    {
      id: 'reservation',
      routerProps: {
        path: settingsRoutes.reservation,
        element: <Reservation />,
      },
    },
    {
      id: 'financing',
      routerProps: {
        path: settingsRoutes.financing,
        element: <Financing />,
      },
      requiredPermission: permissions.readSettings,
      requiredFeatureFlag: featureFlags.SALES_COSTS_WITH_VAT,
    },
    {
      id: 'locale',
      routerProps: {
        path: settingsRoutes.locale,
        element: <Locale />,
      },
      requiredPermission: permissions.readSettings,
    },
    {
      id: 'inspections',
      routerProps: {
        path: settingsRoutes.inspections,
        element: <Inspections />,
      },
      requiredPermission: permissions.readSettings,
    },
    {
      id: 'inspectionsDetail',
      routerProps: {
        path: settingsRoutes.inspectionDetail,
        element: <InspectionsDetail />,
      },
      requiredPermission: permissions.readSettings,
    },
    {
      id: 'checkinInspection',
      routerProps: {
        path: settingsRoutes.checkinInspection,
        element: <CheckinInspection />,
      },
      requiredPermission: permissions.readSettings,
    },
    {
      id: 'handoverInspection',
      routerProps: {
        path: settingsRoutes.handoverInspection,
        element: <HandoverInspection />,
      },
      requiredPermission: permissions.readSettings,
    },
    {
      id: 'workType',
      routerProps: {
        path: settingsRoutes.workType,
        element: <WorkType />,
      },
      requiredPermission: permissions.readSettings,
    },
    {
      id: 'workTypeCreate',
      routerProps: {
        path: settingsRoutes.workTypeCreate,
        element: <WorkTypeDetail />,
      },
      requiredPermission: permissions.readSettings,
    },
    {
      id: 'workTypeDetail',
      routerProps: {
        path: settingsRoutes.workTypeDetail,
        element: <WorkTypeDetail />,
      },
      requiredPermission: permissions.readSettings,
    },
    {
      id: 'employeeCompetences',
      routerProps: {
        path: settingsRoutes.employeeCompetences,
        element: <EmployeeCompetencesOverview />,
      },
      requiredPermission: [permissions.readSettings, permissions.employeeRead],
    },
    {
      id: 'employeeCompetencesCreate',
      routerProps: {
        path: settingsRoutes.employeeCompetencesCreate,
        element: <EmployeeCompetencesDetail />,
      },
      requiredPermission: [permissions.readSettings, permissions.employeeRead],
    },
    {
      id: 'employeeCompetencesDetail',
      routerProps: {
        path: settingsRoutes.employeeCompetencesDetail,
        element: <EmployeeCompetencesDetail />,
      },
      requiredPermission: [permissions.readSettings, permissions.employeeRead],
    },
    {
      id: 'vehicleGroups',
      routerProps: {
        path: settingsRoutes.vehicleGroups,
        element: <VehicleGroups />,
      },
      requiredPermission: permissions.readSettings,
    },
    {
      id: 'vehicleGroupsCreate',
      routerProps: {
        path: settingsRoutes.vehicleGroupsCreate,
        element: <VehicleGroupsDetail />,
      },
      requiredPermission: permissions.readSettings,
    },
    {
      id: 'vehicleGroupsDetail',
      routerProps: {
        path: settingsRoutes.vehicleGroupsDetail,
        element: <VehicleGroupsDetail />,
      },
      requiredPermission: permissions.readSettings,
    },
    {
      id: 'chatSettings',
      routerProps: {
        path: settingsRoutes.chatSettings,
        element: <ChatSettings />,
      },
      requiredPermission: permissions.readSettings,
      requiredFeatureFlag: featureFlags.CHAT_FEATURE,
    },
    {
      id: 'employeeCostCenters',
      routerProps: {
        path: settingsRoutes.employeeCostCenters,
        element: <EmployeeCostCentersOverview />,
      },
      requiredPermission: [permissions.readSettings, permissions.employeeRead],
    },
    {
      id: 'employeeCostCentersCreate',
      routerProps: {
        path: settingsRoutes.employeeCostCentersCreate,
        element: <EmployeeCostCentersDetail />,
      },
      requiredPermission: [permissions.readSettings, permissions.employeeRead],
    },
    {
      id: 'employeeCostCentersDetail',
      routerProps: {
        path: settingsRoutes.employeeCostCentersDetail,
        element: <EmployeeCostCentersDetail />,
      },
      requiredPermission: [permissions.readSettings, permissions.employeeRead],
    },
    {
      id: 'employeeWorkTeams',
      routerProps: {
        path: settingsRoutes.employeeWorkTeams,
        element: <EmployeeWorkTeamsOverview />,
      },
      requiredPermission: [permissions.readSettings, permissions.employeeRead],
    },
    {
      id: 'employeeWorkTeamsCreate',
      routerProps: {
        path: settingsRoutes.employeeWorkTeamsCreate,
        element: <EmployeeWorkTeamsDetail />,
      },
      requiredPermission: [permissions.readSettings, permissions.employeeRead],
    },
    {
      id: 'employeeWorkTeamsDetail',
      routerProps: {
        path: settingsRoutes.employeeWorkTeamsDetail,
        element: <EmployeeWorkTeamsDetail />,
      },
      requiredPermission: [permissions.readSettings, permissions.employeeRead],
    },
    {
      id: 'labourRates',
      routerProps: {
        path: settingsRoutes.labourRates,
        element: <LabourRates />,
      },
      requiredPermission: permissions.readSettings,
    },
    {
      id: 'labourRatesCreate',
      routerProps: {
        path: settingsRoutes.labourRatesCreate,
        element: <LabourRatesDetail />,
      },
      requiredPermission: permissions.readSettings,
    },
    {
      id: 'labourRatesDetail',
      routerProps: {
        path: settingsRoutes.labourRatesDetail,
        element: <LabourRatesDetail />,
      },
      requiredPermission: permissions.readSettings,
    },
    {
      id: 'employeeProfessions',
      routerProps: {
        path: settingsRoutes.employeeProfessions,
        element: <EmployeeProfessionsOverview />,
      },
      requiredPermission: [permissions.readSettings, permissions.employeeRead],
    },
    {
      id: 'employeeProfessionsCreate',
      routerProps: {
        path: settingsRoutes.employeeProfessionsCreate,
        element: <EmployeeProfessionsDetail />,
      },
      requiredPermission: [permissions.readSettings, permissions.employeeRead],
    },
    {
      id: 'employeeProfessionsDetail',
      routerProps: {
        path: settingsRoutes.employeeProfessionsDetail,
        element: <EmployeeProfessionsDetail />,
      },
      requiredPermission: [permissions.readSettings, permissions.employeeRead],
    },
    {
      id: 'serviceCaseType',
      routerProps: {
        path: settingsRoutes.serviceCaseType,
        element: <ServiceCaseType />,
      },
      requiredPermission: permissions.readSettings,
    },
    {
      id: 'serviceCaseTypeDetail',
      routerProps: {
        path: settingsRoutes.serviceCaseTypeDetail,
        element: <ServiceCaseTypeDetail />,
      },
      requiredPermission: permissions.readSettings,
    },
    {
      id: 'serviceCaseTypeCreate',
      routerProps: {
        path: settingsRoutes.serviceCaseTypeCreate,
        element: <ServiceCaseTypeDetail />,
      },
      requiredPermission: permissions.readSettings,
    },
    {
      id: 'serviceOrderVariants',
      routerProps: {
        path: settingsRoutes.serviceOrderVariants,
        element: <WorkshopServiceOrderVariants />,
      },
      requiredPermission: permissions.readSettings,
    },
    {
      id: 'serviceOrderVariantsCreate',
      routerProps: {
        path: settingsRoutes.serviceOrderVariantsCreate,
        element: <ServiceOrderVariantsDetail />,
      },
      requiredPermission: permissions.readSettings,
    },
    {
      id: 'serviceOrderVariantsDetail',
      routerProps: {
        path: settingsRoutes.serviceOrderVariantsDetail,
        element: <ServiceOrderVariantsDetail />,
      },
      requiredPermission: permissions.readSettings,
    },
    {
      id: 'salesServiceOrderVariants',
      routerProps: {
        path: settingsRoutes.salesServiceOrderVariants,
        element: <SalesServiceOrderVariants />,
      },
      requiredPermission: permissions.readSettings,
    },
    {
      id: 'salesServiceOrderVariantsDetail',
      routerProps: {
        path: settingsRoutes.salesServiceOrderVariantsDetail,
        element: <ServiceOrderVariantsDetail />,
      },
      requiredPermission: permissions.readSettings,
    },
    {
      id: 'labourCatalogues',
      routerProps: {
        path: settingsRoutes.labourCatalogues,
        element: <LabourCatalogues />,
      },
      requiredPermission: permissions.readSettings,
    },
    {
      id: 'labourCataloguesCreate',
      routerProps: {
        path: settingsRoutes.labourCataloguesCreate,
        element: <LabourCataloguesDetail />,
      },
      requiredPermission: permissions.readSettings,
    },
    {
      id: 'labourCataloguesDetail',
      routerProps: {
        path: settingsRoutes.labourCataloguesDetail,
        element: <LabourCataloguesDetail />,
      },
      requiredPermission: permissions.readSettings,
    },
    {
      id: 'workshopCustomerGroups',
      routerProps: {
        path: settingsRoutes.workshopCustomerGroups,
        element: <WorkshopCustomerGroups />,
      },
      requiredPermission: permissions.readSettings,
    },
    {
      id: 'workshopCustomerGroupCreate',
      routerProps: {
        path: settingsRoutes.workshopCustomerGroupCreate,
        element: <WorkshopCustomerGroupFormPage />,
      },
      requiredPermission: permissions.readSettings,
    },
    {
      id: 'workshopCustomerGroupDetail',
      routerProps: {
        path: settingsRoutes.workshopCustomerGroupDetail,
        element: <WorkshopCustomerGroupFormPage />,
      },
      requiredPermission: permissions.readSettings,
    },
    {
      id: 'workshopSelectableMaterials',
      routerProps: {
        path: settingsRoutes.workshopSelectableMaterials,
        element: <WorkshopSelectableMaterials />,
      },
      requiredPermission: permissions.readSettings,
    },
    {
      id: 'workshopSelectableMaterialsDetail',
      routerProps: {
        path: settingsRoutes.workshopSelectableMaterialsDetail,
        element: <WorkshopSelectableMaterialsDetail />,
      },
      requiredPermission: permissions.readSettings,
    },
    {
      id: 'workshopMinorUnitMaterial',
      routerProps: {
        path: settingsRoutes.workshopSmallUnitMaterial,
        element: <WorkshopSmallUnitMaterials />,
      },
      requiredPermission: permissions.readSettings,
    },
    {
      id: 'workshopMinorUnitMaterialDetail',
      routerProps: {
        path: settingsRoutes.workshopSmallUnitMaterialDetail,
        element: <WorkshopSmallUnitMaterialDetail />,
      },
      requiredPermission: permissions.readSettings,
    },
    {
      id: 'workshopMinorUnitMaterialCreate',
      routerProps: {
        path: settingsRoutes.workshopSmallUnitMaterialCreate,
        element: <WorkshopSmallUnitMaterialDetail />,
      },
      requiredPermission: permissions.readSettings,
    },
    {
      id: 'customerContracts',
      routerProps: {
        path: settingsRoutes.customerContracts,
        element: <CustomerContracts />,
      },
      requiredPermission: permissions.readSettings,
    },
    {
      id: 'customerContractsCreate',
      routerProps: {
        path: settingsRoutes.customerContractsCreate,
        element: <CustomerContractsDetail />,
      },
      requiredPermission: permissions.readSettings,
    },
    {
      id: 'customerContractsDetail',
      routerProps: {
        path: settingsRoutes.customerContractsDetail,
        element: <CustomerContractsDetail />,
      },
      requiredPermission: permissions.readSettings,
    },
    {
      id: 'tiresInventory',
      routerProps: {
        path: settingsRoutes.tiresInventory,
        element: <TiresInventory />,
      },
      requiredPermission: permissions.readSettings,
    },
    {
      id: 'tiresInventoryDetail',
      routerProps: {
        path: settingsRoutes.tiresInventoryDetail,
        element: <TiresInventoryDetail />,
      },
      requiredPermission: permissions.readSettings,
    },
    {
      id: 'tiresInventoryCreate',
      routerProps: {
        path: settingsRoutes.tiresInventoryCreate,
        element: <TiresInventoryDetail />,
      },
      requiredPermission: permissions.readSettings,
    },
    {
      id: 'tireTransit',
      routerProps: {
        path: settingsRoutes.tireTransit,
        element: <TireTransit />,
      },
      requiredPermission: permissions.readSettings,
    },
    {
      id: 'tireTransitDetail',
      routerProps: {
        path: settingsRoutes.tireTransitDetail,
        element: <TireTransitDetail />,
      },
      requiredPermission: permissions.readSettings,
    },
    {
      id: 'tireTransitCreate',
      routerProps: {
        path: settingsRoutes.tireTransitCreate,
        element: <TireTransitDetail />,
      },
      requiredPermission: permissions.readSettings,
    },
    {
      id: 'tireManufacturers',
      routerProps: {
        path: settingsRoutes.tireManufacturers,
        element: <TireInventoryManufacturers />,
      },
      requiredPermission: permissions.readSettings,
    },
    {
      id: 'tireLocations',
      routerProps: {
        path: settingsRoutes.tireLocations,
        element: <TireInventoryLocations />,
      },
      requiredPermission: permissions.readSettings,
    },
    {
      id: 'tireWarehouses',
      routerProps: {
        path: settingsRoutes.tireWarehouses,
        element: <TireWarehouses />,
      },
      requiredPermission: permissions.readSettings,
    },
    {
      id: 'tireWarehousesCreate',
      routerProps: {
        path: settingsRoutes.tireWarehousesCreate,
        element: <TireWarehousesCreate />,
      },
      requiredPermission: permissions.readSettings,
    },
    {
      id: 'tireWarehousesDetail',
      routerProps: {
        path: settingsRoutes.tireWarehousesDetail,
        element: <TireWarehousesDetail />,
      },
      requiredPermission: permissions.readSettings,
    },
    {
      id: 'workshopServicePackages',
      routerProps: {
        path: settingsRoutes.workshopServicePackages,
        element: <WorkshopServicePackages />,
      },
      requiredPermission: permissions.readSettings,
    },
    {
      id: 'workshopCreateServicePackages',
      routerProps: {
        path: settingsRoutes.workshopCreateServicePackages,
        element: <WorkshopServicePackageDetail />,
      },
      requiredPermission: permissions.readSettings,
    },
    {
      id: 'workshopEditServicePackages',
      routerProps: {
        path: settingsRoutes.workshopEditServicePackages,
        element: <WorkshopServicePackageDetail />,
      },
      requiredPermission: permissions.readSettings,
    },
    {
      id: 'workshopMeasurementUnits',
      routerProps: {
        path: settingsRoutes.workshopMeasurementUnits,
        element: <WorkshopMeasurementUnits />,
      },
      requiredPermission: permissions.readSettings,
    },
    {
      id: 'workshopMeasurementUnitCreate',
      routerProps: {
        path: settingsRoutes.workshopMeasurementUnitCreate,
        element: <WorkshopMeasurementUnitDetail />,
      },
      requiredPermission: permissions.readSettings,
    },
    {
      id: 'workshopMeasurementUnitDetail',
      routerProps: {
        path: settingsRoutes.workshopMeasurementUnitDetail,
        element: <WorkshopMeasurementUnitDetail />,
      },
      requiredPermission: permissions.readSettings,
    },
    {
      id: 'workshopServiceOrderGroups',
      routerProps: {
        path: settingsRoutes.workshopServiceOrderGroups,
        element: <WorkshopServiceOrderGroups />,
      },
      requiredPermission: permissions.readSettings,
    },
    {
      id: 'workshopServiceOrderGroupCreate',
      routerProps: {
        path: settingsRoutes.workshopServiceOrderGroupCreate,
        element: <WorkshopServiceOrderGroupDetail />,
      },
      requiredPermission: permissions.readSettings,
    },
    {
      id: 'workshopServiceOrderGroupDetail',
      routerProps: {
        path: settingsRoutes.workshopServiceOrderGroupDetail,
        element: <WorkshopServiceOrderGroupDetail />,
      },
      requiredPermission: permissions.readSettings,
    },
    {
      id: 'workshopInterest',
      routerProps: {
        path: settingsRoutes.workshopInterest,
        element: <WorkshopInterest />,
      },
      requiredFeatureFlag: featureFlags.WORKSHOP_INTEREST,
      requiredPermission: permissions.readSettings,
    },
    {
      id: 'workshopInterestSeriesDefinition',
      routerProps: {
        path: settingsRoutes.workshopInterestSeriesDefinition,
        element: <WorkshopInterestSeriesDefinition />,
      },
      requiredFeatureFlag: featureFlags.WORKSHOP_INTEREST,
      requiredPermission: permissions.readSettings,
    },
    {
      id: 'workshopInterestSourceCodelist',
      routerProps: {
        path: settingsRoutes.workshopInterestSourceCodelist,
        element: <WorkshopCodelistDetail />,
      },
      requiredFeatureFlag: featureFlags.WORKSHOP_INTEREST,
      requiredPermission: permissions.readSettings,
    },
    {
      id: 'generalChecklist',
      routerProps: {
        path: settingsRoutes.generalChecklist,
        element: <Checklist />,
      },
    },
    {
      id: 'generalChecklistCreate',
      routerProps: {
        path: settingsRoutes.generalChecklistCreate,
        element: <ChecklistCreate />,
      },
    },
    {
      id: 'generalChecklistDetail',
      routerProps: {
        path: settingsRoutes.generalChecklistDetail,
        element: <ChecklistDetail />,
      },
    },
    {
      id: 'tireWidth',
      routerProps: {
        path: settingsRoutes.tireWidth,
        element: <TireInventoryWidth />,
      },
      requiredPermission: permissions.readSettings,
    },
    {
      id: 'tireWidthDetail  ',
      routerProps: {
        path: settingsRoutes.tireWidthDetail,
        element: <TireInventoryWidthDetail />,
      },
      requiredPermission: permissions.readSettings,
    },
    {
      id: 'tireWidthCreate',
      routerProps: {
        path: settingsRoutes.tireWidthCreate,
        element: <TireInventoryWidthDetail />,
      },
      requiredPermission: permissions.readSettings,
    },
    {
      id: 'tireAspectRatio',
      routerProps: {
        path: settingsRoutes.tireAspectRatio,
        element: <TireInventoryAspectRatio />,
      },
      requiredPermission: permissions.readSettings,
    },
    {
      id: 'tireAspectRatioDetail',
      routerProps: {
        path: settingsRoutes.tireAspectRatioDetail,
        element: <TireInventoryAspectRatioDetail />,
      },
      requiredPermission: permissions.readSettings,
    },
    {
      id: 'tireAspectRatioCreate',
      routerProps: {
        path: settingsRoutes.tireAspectRatioCreate,
        element: <TireInventoryAspectRatioDetail />,
      },
      requiredPermission: permissions.readSettings,
    },
    {
      id: 'tireRimSize',
      routerProps: {
        path: settingsRoutes.tireRimSize,
        element: <TireInventoryRim />,
      },
      requiredPermission: permissions.readSettings,
    },
    {
      id: 'tireRimSizeDetail',
      routerProps: {
        path: settingsRoutes.tireRimSizeDetail,
        element: <TireInventoryRimDetail />,
      },
      requiredPermission: permissions.readSettings,
    },
    {
      id: 'tireRimSizeCreate',
      routerProps: {
        path: settingsRoutes.tireRimSizeCreate,
        element: <TireInventoryRimDetail />,
      },
      requiredPermission: permissions.readSettings,
    },
    {
      id: 'tireSpeedRatio',
      routerProps: {
        path: settingsRoutes.tireSpeedRatio,
        element: <TireInventorySpeedRatio />,
      },
      requiredPermission: permissions.readSettings,
    },
    {
      id: 'tireSpeedRatioDetail',
      routerProps: {
        path: settingsRoutes.tireSpeedRatioDetail,
        element: <TireInventorySpeedRatioDetail />,
      },
      requiredPermission: permissions.readSettings,
    },
    {
      id: 'tireSpeedRatioCreate',
      routerProps: {
        path: settingsRoutes.tireSpeedRatioCreate,
        element: <TireInventorySpeedRatioDetail />,
      },
      requiredPermission: permissions.readSettings,
    },
    {
      id: 'tireCategory',
      routerProps: {
        path: settingsRoutes.tireCategory,
        element: <TireInventoryCategory />,
      },
      requiredPermission: permissions.readSettings,
    },
    {
      id: 'tireCategoryDetail',
      routerProps: {
        path: settingsRoutes.tireCategoryDetail,
        element: <TireInventoryCategoryDetail />,
      },
      requiredPermission: permissions.readSettings,
    },
    {
      id: 'tireCategoryCreate',
      routerProps: {
        path: settingsRoutes.tireCategoryCreate,
        element: <TireInventoryCategoryDetail />,
      },
      requiredPermission: permissions.readSettings,
    },
    {
      id: 'tireCondition',
      routerProps: {
        path: settingsRoutes.tireCondition,
        element: <TireCondition />,
      },
      requiredPermission: permissions.readSettings,
    },
    {
      id: 'tireConditionDetail',
      routerProps: {
        path: settingsRoutes.tireConditionDetail,
        element: <TireConditionDetail />,
      },
      requiredPermission: permissions.readSettings,
    },
    {
      id: 'tireConditionCreate',
      routerProps: {
        path: settingsRoutes.tireConditionCreate,
        element: <TireConditionDetail />,
      },
      requiredPermission: permissions.readSettings,
    },
    {
      id: 'workshopUnits',
      routerProps: {
        path: settingsRoutes.workshopUnits,
        element: <WorkshopUnits />,
      },
      requiredPermission: permissions.readSettings,
    },
    {
      id: 'workshopUnitCreate',
      routerProps: {
        path: settingsRoutes.workshopUnitCreate,
        element: <WorkshopUnitsDetail />,
      },
      requiredPermission: permissions.readSettings,
    },
    {
      id: 'workshopUnitDetail',
      routerProps: {
        path: settingsRoutes.workshopUnitDetail,
        element: <WorkshopUnitsDetail />,
      },
      requiredPermission: permissions.readSettings,
    },
    {
      id: 'tireLoadIndex',
      routerProps: {
        path: settingsRoutes.tireLoadIndex,
        element: <TireInventoryLoadIndex />,
      },
      requiredPermission: permissions.readSettings,
    },
    {
      id: 'tireLoadIndexDetail',
      routerProps: {
        path: settingsRoutes.tireLoadIndexDetail,
        element: <TireInventoryLoadIndexDetail />,
      },
      requiredPermission: permissions.readSettings,
    },
    {
      id: 'tireLoadIndexCreate',
      routerProps: {
        path: settingsRoutes.tireLoadIndexCreate,
        element: <TireInventoryLoadIndexDetail />,
      },
      requiredPermission: permissions.readSettings,
    },
    {
      id: 'mandatoryFields',
      routerProps: {
        path: settingsRoutes.mandatoryFields,
        element: <MandatoryFields />,
      },
      requiredPermission: permissions.readMandatoryFields,
    },
    {
      id: 'workshopVehicleClasses',
      routerProps: {
        path: settingsRoutes.workshopVehicleClasses,
        element: <WorkshopVehicleClasses />,
      },
      requiredPermission: permissions.readSettings,
    },
    {
      id: 'workshopVehicleClassCreate',
      routerProps: {
        path: settingsRoutes.workshopVehicleClassCreate,
        element: <WorkshopVehicleClassDetail />,
      },
      requiredPermission: permissions.readSettings,
    },
    {
      id: 'workshopVehicleClassDetail',
      routerProps: {
        path: settingsRoutes.workshopVehicleClassDetail,
        element: <WorkshopVehicleClassDetail />,
      },
      requiredPermission: permissions.readSettings,
    },
    {
      id: 'workshopInsuranceTypes',
      routerProps: {
        path: settingsRoutes.workshopInsuranceTypes,
        element: <WorkshopInsuranceTypes />,
      },
      requiredPermission: permissions.readSettings,
    },
    {
      id: 'workshopInsuranceTypesCreate',
      routerProps: {
        path: settingsRoutes.workshopInsuranceTypesCreate,
        element: <WorkshopInsuranceTypeDetail />,
      },
      requiredPermission: permissions.readSettings,
    },
    {
      id: 'workshopInsuranceTypesDetail',
      routerProps: {
        path: settingsRoutes.workshopInsuranceTypesDetail,
        element: <WorkshopInsuranceTypeDetail />,
      },
      requiredPermission: permissions.readSettings,
    },
    {
      id: 'partDepartment',
      routerProps: {
        path: settingsRoutes.partDepartment,
        element: <PartDepartment />,
      },
      requiredPermission: permissions.readSettings,
    },
    {
      id: 'twoFactorSettings',
      routerProps: {
        path: settingsRoutes.twoFactorSettings,
        element: <TwoFactorSettings />,
      },
      requiredPermission: permissions.canReadTenantMultiFactorAuthenticationSettings,
      requiredFeatureFlag: featureFlags.SETTINGS_TWO_FACTOR_AUTH,
    },
    {
      id: 'scheduledMessages',
      routerProps: {
        path: settingsRoutes.scheduledMessages,
        element: <ScheduledMessagesOverview />,
      },
      requiredPermission: permissions.readSettings,
      requiredFeatureFlag: featureFlags.SCHEDULED_MESSAGES,
    },
    {
      id: 'scheduledMessagesDetail',
      routerProps: {
        path: settingsRoutes.scheduledMessagesDetail,
        element: <ScheduledMessagesDetail />,
      },
      requiredPermission: permissions.readSettings,
      requiredFeatureFlag: featureFlags.SCHEDULED_MESSAGES,
    },
  ],
};
